<header
  [style.background-color]="customBackgroundColor ? customBackgroundColor : null"
  [style.height.px]="height()"
>
  <ng-content select="slot-header-left, [slot='header-left']"></ng-content>
  <ng-content select="slot-header-center, [slot='header-center']"></ng-content>
  <ng-content select="slot-header-right, [slot='header-right']"></ng-content>
</header>
